export default {
  responsive: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "(Preview) Responsive",
      description: "The visual will adapt to size changes"
    },
    value: true
  },
  show: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Show",
      description: null
    },
    value: true
  },
  showAllDataPoints: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Show all",
      description: null
    },
    value: false
  },
  showAll: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Customize series",
      description: null
    },
    value: false
  },
  showSeries: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Show series",
      description: null
    },
    value: false
  },
  enableBackground: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Enable Background",
      description: null
    },
    value: false
  },
  autoZoom: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Auto Zoom",
      description: null
    },
    value: true
  },
  gridVertical: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Vert grid",
      description: "Show/Hide the vertical gridlines"
    },
    value: true
  },
  gridHorizontal: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Horiz grid",
      description: "Show/Hide the horizontal gridlines"
    },
    value: true
  },
  urlIcon: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "URL icon",
      description: "Show an icon instead of the full URL"
    },
    value: true
  },
  circleDefaultIcon: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Circle Default Icon",
      description: null
    },
    value: true
  },
  invertAxis:{
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Invert Axis",
      description: null
    },
    value: true
  },
  showExpandCollapseButtons: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Expand Collapse Buttons",
      description: null
    },
    value: true
  },
  wordWrap: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Word wrap",
      description: null
    },
    value: true
  },

  showTitle: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Title",
      description: "Display a title for legend symbols"
    },
    value: true
  },
  selectionZoom: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Selection Zoom",
      description: null
    },
    value: true
  },
  manualZoom: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Manual Zoom",
      description: null
    },
    value: true
  },
  perRowLevel: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Row Level",
      description: null
    },
    value: true
  },
  perColumnLevel: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Column Level",
      description: "Display a title for legend symbols"
    },
    value: true
  },
  gridlineShow: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Gridline Show",
      description: null
    },
    value: true
  },
  bandedRowHeaders: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Banded row style",
      description: "Apply banded row style to the last level of the row group headers, using the colors of the values."
    },
    value: true
  },
  valuesOnRow: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Show on rows",
      description: "Show values in row groups rather than columns"
    },
    value: true
  },
  rowSubtotals: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Total row",
      description: null
    },
    value: true
  },
  totals: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Totals",
      description: null
    },
    value: true
  },
  defaultShow: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Visible",
      description: null
    },
    value: true
  },
  selectAllCheckboxEnabled: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "All Checkbox Enabled",
      description: null
    },
    value: false
  },
  singleSelect: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Single Select",
      description: null
    },
    value: true
  },
  strictSingleSelect: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Strict Single Select",
      description: null
    },
    value: true
  },
  showVisualInformationButton: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Visual information icon",
      description: null
    },
    value: true
  },
  showVisualWarningButton: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Visual warning icon",
      description: null
    },
    value: true
  },
  showVisualErrorButton: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Visual error icon",
      description: null
    },
    value: true
  },
  showDrillRoleSelector: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Drill down icon",
      description: null
    },
    value: true
  },
  showDrillUpButton: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Drill up icon",
      description: null
    },
    value: true
  },
  showDrillToggleButton: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Drill on dropdown",
      description: null
    },
    value: true
  },
  showDrillDownLevelButton: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Show next level icon",
      description: null
    },
    value: true
  },
  showDrillDownExpandButton: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Expand to next level icon",
      description: null
    },
    value: true
  },
  showPinButton: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Pin icon",
      description: null
    },
    value: true
  },
  showFocusModeButton: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Focus mode icon",
      description: null
    },
    value: true
  },
  showFilterRestatementButton: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Filter icon",
      description: null
    },
    value: true
  },
  showSeeDataLayoutToggleButton: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "See data layout icon",
      description: null
    },
    value: true
  },
  showOptionsMenu: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "More options icon",
      description: null
    },
    value: true
  },
  showTooltipButton: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Visual header tooltip icon",
      description: null
    },
    value: true
  },
  aiEnabled: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "AI Enabled",
      description: null
    },
    value: true
  },
  columnSubtotals: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Total column",
      description: null
    },
    value: true
  },
  showBorder: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Show Border",
      description: null
    },
    value: true
  },
  border: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Show Border",
      description: null
    },
    value: true
  },
  barShow: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Show bar",
      description: "Display a bar to the left side of the card as an accent"
    },
    value: true
  },
  applyToHeaders: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Apply to labels",
      description: null
    },
    value: true
  },
  allowKeyDrivers: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Enable key influencers",
      description: null
    },
    value: true
  },
  allowProfiles: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Enable segments",
      description: null
    },
    value: true
  },
  allowKeyDriversCounting: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Enable counts",
      description: null
    },
    value: false
  },
  zoomTools: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Zoom Tools",
      description: null
    },
    value: false
  },
  basemaps: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Basemaps",
      description: null
    },
    value: false
  },
  preserveWhitespace: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Whitespace",
      description: null
    },
    value: false
  },
  lockMapExtent: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Lock extent",
      description: null
    },
    value: false
  },
  geoSearch: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Search",
      description: null
    },
    value: false
  },
  titleWrap: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Word wrap",
      description: null
    },
    value: false
  },
  showTooltipButton: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Tooltip Button",
      description: null
    },
    value: true
  },
  showGoal: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Goal",
      description: null
    },
    value: true
  },
  layerVisible: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Show layers",
      description: null
    },
    value: true
  },
  layerAnchored: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Anchor",
      description: null
    },
    value: false
  },
  showIcon: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Icon",
      description: null
    },
    value: true
  },
  showOnCategoryAxis: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Show category Axis",
      description: null
    },
    value: true
  },
  showOnValueAxis: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Show value Axis",
      description: null
    },
    value: true
  },
  showTooltip: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Show value Axis",
      description: null
    },
    value: true
  },
  showPositiveAndNegative: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Show positive and negative",
      description: null
    },
    value: true
  },
  showLabels: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Show labels",
      description: null
    },
    value: true
  },
  showDistance: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Distance",
      description: null
    },
    value: true
  },
  paramButton: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Parameters",
      description: null
    },
    value: true
  },
  stepped: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Stepped layout",
      description: "Render row headers with stepped layout"
    },
    value: true
  },
  autoSizeColumnWidth: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Auto-size column width",
      description: null
    },
    value: true
  },
  showMarker: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Show marker",
      description: null
    },
    value: false
  },
  customizeSeries: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Сustomize Series",
      description: null
    },
    value: false
  },
  matchLineColor: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Match Line Color",
      description: null
    },
    value: false
  },
  shadeArea: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Shade area",
      description: null
    },
    value: false
  },
  colorBands: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Color Bands",
      description: null
    },
    value: false
  },
  showAxisTitle: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Title",
      description: "Title for the X-axis"
    },
    value: true
  },


  concatenateLabels: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Concatenate labels",
      description: "Always concatenate levels of the hierarchy instead of drawing the hierarchy."
    },
    value: "showTitleOnly"
  },

  secShow: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Show secondary",
      description: null
    },
    value: false
  },
  labelOverflow: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Label Overflow",
      description: null
    },
    value: false
  },
  overflow: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Overflow",
      description: null
    },
    value: false
  },
  alignZeros: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Align zeros",
      description: "Align the zero tick marks for both value axes"
    },
    value: false
  },
  secShowAxisTitle: {
    properties: {
      component: 'Switcher',
      type: "bool",
      displayName: "Title",
      description: "Title for the Y-axis"
    },
    value: false
  },
}